import { useMemo } from 'react';

// Mapping des noms SEO-friendly vers les fichiers locaux servis par le site
const imageMapping: Record<string, string> = {
  // Logo Nokodia - images locales SEO-friendly
  'nokodia-logo.webp': '/lovable-uploads/Nokodia_Logo.webp',
  'nokodia-logo-fond-noir.webp': '/lovable-uploads/Nokodia_Logo_Fond_Noir.webp',
  
  // Assets Nokodia - images locales SEO-friendly
  'nokodia-vision.webp': '/lovable-uploads/Nokodia_Vision.webp',
  'nokodia-flow.webp': '/lovable-uploads/Nokodia_Flow.webp',
  'nokodia-focus.webp': '/lovable-uploads/Nokodia_Focus.webp',
  'nokodia-empowerment.webp': '/lovable-uploads/Nokodia_Empowerment.webp',
  // nokodia-production.webp : image à fournir par l'utilisateur — fallback temporaire sur Focus
  'nokodia-production.webp': '/lovable-uploads/Nokodia_Production.webp',
  'nokodia-ai-transformation.mp4': '/lovable-uploads/SD_Nokodia-AI-Learning-Transformation.mp4',
  'nokodia-ai-transformation.png': '/lovable-uploads/Nokodia_AI_Transformation.png',
  'nokodia-og-picture.png': '/images/site-visuals/nokodia-og.webp',
  
  // Images de diagnostic - images locales SEO-friendly
  'ai-digital-transformation-diagnostic.png': '/lovable-uploads/AI_Digital_Transformation_Diagnostic.png',
  'ai-learning-strategy-diagnostic.png': '/lovable-uploads/AI_Learning_Strategy_Diagnostic.png'
};

export const useImageProxy = () => {
  const getImageUrl = useMemo(() => {
    return (imageName: string): string => {
      // Retourne le chemin local mappé, sinon la valeur d'origine
      return imageMapping[imageName] ?? imageName;
    };
  }, []);

  const getProxyUrl = useMemo(() => {
    return (imageName: string): string => {
      return getImageUrl(imageName);
    };
  }, [getImageUrl]);

  const getAltText = (imageName: string): string => {
    const altMapping: Record<string, string> = {
      // Assets Nokodia
      'nokodia-logo.webp': 'Nokodia - Conseil transformation digitale IA formation',
      'nokodia-vision.webp': 'Vision - Conseil stratégique transformation digitale IA Nokodia',
      'nokodia-flow.webp': 'Flow - Déploiement solutions IA Nokodia',
      'nokodia-focus.webp': 'Focus - Impact et optimisation ROI IA Nokodia',
      'nokodia-empowerment.webp': 'Empowerment - Formation et change management IA Nokodia',
      'nokodia-ai-transformation.mp4': 'Vidéo présentation Nokodia - Transformation digitale IA formation',
      'nokodia-ai-transformation.png': 'Nokodia - Transformation digitale IA formation - Image principale',
      'nokodia-og-picture.png': 'Nokodia, conseil et services L&D pour transformer la formation',
      
      // Nouvelles images de diagnostic
      'ai-digital-transformation-diagnostic.png': 'Diagnostic AI Digital Transformation - Illustration évaluation maturité IA entreprise',
      'ai-learning-strategy-diagnostic.png': 'Diagnostic AI Training Transformation - Évaluation stratégie formation IA'
    };
    
    return altMapping[imageName] || imageName;
  };

  // Fonction pour obtenir les dimensions d'image optimisées pour PageSpeed
  const getImageDimensions = (imageName: string): { width: number; height: number } => {
    const dimensionsMapping: Record<string, { width: number; height: number }> = {
      // Logo Nokodia - optimisé pour header/footer
      'nokodia-logo.webp': { width: 120, height: 32 },
      
      // Images des piliers - optimisées pour les cartes
      'nokodia-vision.webp': { width: 32, height: 32 },
      'nokodia-flow.webp': { width: 32, height: 32 },
      'nokodia-focus.webp': { width: 32, height: 32 },
      'nokodia-empowerment.webp': { width: 32, height: 32 },
      
      // Images de diagnostic
      'ai-digital-transformation-diagnostic.png': { width: 400, height: 300 },
      'ai-learning-strategy-diagnostic.png': { width: 400, height: 300 },
    };
    
    return dimensionsMapping[imageName] || { width: 120, height: 60 };
  };

  return { getImageUrl, getProxyUrl, getAltText, getImageDimensions };
};
